// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as SearchAlgoJs from "./SearchAlgo.js";
import Input from "@mui/material/Input";
import Clear from "@mui/icons-material/Clear";
import Search from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";

function matchSearch(prim0, prim1) {
  return SearchAlgoJs.matchSearch(prim0, prim1);
}

function matchSearch2(prim0, prim1, prim2) {
  return SearchAlgoJs.matchSearch2(prim0, prim1, prim2);
}

function SearchField2(Props) {
  var search = Props.search;
  var setSearch = Props.setSearch;
  var t = Translation.useT(/* Common */0);
  var inputRef = React.useRef(undefined);
  React.useEffect((function () {
          var cb = function (e) {
            if (!(e.ctrlKey && e.keyCode === 71)) {
              return ;
            }
            var inputRef$1 = inputRef.current;
            if (inputRef$1 !== undefined) {
              e.preventDefault();
              Caml_option.valFromOption(inputRef$1).focus();
              return ;
            }
            
          };
          document.addEventListener("keydown", cb);
          return (function (param) {
                    document.removeEventListener("keydown", cb);
                    
                  });
        }), []);
  return React.createElement(Input, {
              placeholder: t("Search"),
              inputRef: (function (v) {
                  inputRef.current = (v == null) ? undefined : Caml_option.some(v);
                  
                }),
              value: search,
              onChange: (function (e) {
                  var v = e.target.value;
                  return Curry._1(setSearch, (function (param) {
                                return v;
                              }));
                }),
              startAdornment: React.createElement("div", {
                    className: "text-white1"
                  }, React.createElement(InputAdornment, {
                        position: "start",
                        children: React.createElement(Search, {
                              color: "inherit"
                            })
                      })),
              endAdornment: search !== "" ? React.createElement("div", {
                      className: "cursor-pointer text-white2",
                      onClick: (function (param) {
                          return Curry._1(setSearch, (function (param) {
                                        return "";
                                      }));
                        })
                    }, React.createElement(InputAdornment, {
                          position: "end",
                          children: React.createElement(Clear, {
                                fontSize: "small",
                                color: "inherit"
                              })
                        })) : null
            });
}

var make = SearchField2;

export {
  matchSearch ,
  matchSearch2 ,
  make ,
  
}
/* react Not a pure module */
